import { useState, useEffect } from 'react';
import { getDiscussionUsers } from 'services/chatSesrvice';

export const useGetDiscussionUsers = (userId) => {
  const [data, setData] = useState(null); 
  const [loading, setLoading] = useState(false); 
  const [error, setError] = useState(null); 

  useEffect(() => {
    const fetchDiscussionUsers = async () => {
      if (!userId) return; 

      setLoading(true);
      setError(null);
      try {
        const response = await getDiscussionUsers(userId);
        setData(response.data); 
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };

    fetchDiscussionUsers();
  }, [userId]); 

  return { data, loading, error };
};